import moment from 'moment'

export const formatPercentage = value => {
    const parsed = parseFloat(value)
    if (parsed === 0 || value === '.00') {
        return '0%'
    } else {
        return value
    }
}

export const getRatingTextCount = (rating, surveyResults) => {
    const key = `rating${rating.toString().padStart(2, '0')}TextCount`
    return surveyResults[key] || 0
}

export const getChartDataArray = results => {
    const ratingRegex = /^rating(\d{2})Count$/
    const chartData = Object.entries(results)
        .filter(([key]) => ratingRegex.test(key))
        .map(([key, value]) => {
            const match = key.match(ratingRegex)
            return { name: parseInt(match[1], 10), value }
        })
    return chartData
}

export const getIsDateInRange = (allSurvey, startDate, endDate) =>
    allSurvey?.find(
        currentSurvey =>
            startDate.isBetween(moment(currentSurvey?.dateStart), moment(currentSurvey?.dateEnd), undefined, '[]') ||
            endDate.isBetween(moment(currentSurvey?.dateStart), moment(currentSurvey?.dateEnd), undefined, '[]')
    )

export const getPrefix = (key, validPrefixes) => {
    const prefix = key.substring(0, 2).toLowerCase()
    return validPrefixes.includes(prefix) ? prefix : null
}

export const getSurveyTexts = (data, validPrefixes) => {
    const prefixes = new Set()
    Object.keys(data).forEach(key => {
        const prefix = getPrefix(key, validPrefixes)
        if (prefix) {
            prefixes.add(prefix)
        }
    })
    return Array.from(prefixes).map(prefix => {
        const obj = { language: prefix }
        Object.keys(data).forEach(key => {
            if (key.startsWith(prefix)) {
                obj[key.substring(prefix.length)] = data[key]
            }
        })
        return obj
    })
}

export const downloadCSV = (csvData, survey) => {
    const url = window.URL.createObjectURL(csvData)
    const link = document.createElement('a')
    link.style.visibility = 'hidden'
    link.setAttribute('download', `${survey.name}_survey_data.csv`)
    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
